/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
export var FxIdDomainEntitiesNewsPriority;
(function (FxIdDomainEntitiesNewsPriority) {
    FxIdDomainEntitiesNewsPriority[FxIdDomainEntitiesNewsPriority["Unspecified"] = 0] = "Unspecified";
    FxIdDomainEntitiesNewsPriority[FxIdDomainEntitiesNewsPriority["Low"] = 1] = "Low";
    FxIdDomainEntitiesNewsPriority[FxIdDomainEntitiesNewsPriority["Update"] = 2] = "Update";
    FxIdDomainEntitiesNewsPriority[FxIdDomainEntitiesNewsPriority["Info"] = 3] = "Info";
    FxIdDomainEntitiesNewsPriority[FxIdDomainEntitiesNewsPriority["News"] = 4] = "News";
    FxIdDomainEntitiesNewsPriority[FxIdDomainEntitiesNewsPriority["Alert"] = 5] = "Alert";
    FxIdDomainEntitiesNewsPriority[FxIdDomainEntitiesNewsPriority["Critical"] = 6] = "Critical";
    FxIdDomainEntitiesNewsPriority[FxIdDomainEntitiesNewsPriority["NUMBER_unknown_default_open_api"] = 11184809] = "NUMBER_unknown_default_open_api";
})(FxIdDomainEntitiesNewsPriority || (FxIdDomainEntitiesNewsPriority = {}));
export function instanceOfFxIdDomainEntitiesNewsPriority(value) {
    for (const key in FxIdDomainEntitiesNewsPriority) {
        if (Object.prototype.hasOwnProperty.call(FxIdDomainEntitiesNewsPriority, key)) {
            if (FxIdDomainEntitiesNewsPriority[key] === value) {
                return true;
            }
        }
    }
    return false;
}
export function FxIdDomainEntitiesNewsPriorityFromJSON(json) {
    return FxIdDomainEntitiesNewsPriorityFromJSONTyped(json, false);
}
export function FxIdDomainEntitiesNewsPriorityFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function FxIdDomainEntitiesNewsPriorityToJSON(value) {
    return value;
}
export function FxIdDomainEntitiesNewsPriorityToJSONTyped(value, ignoreDiscriminator) {
    return value;
}
//# sourceMappingURL=FxIdDomainEntitiesNewsPriority.js.map